<template>
    <div>
        <div class="vx-row ml-1 mt-3">
            <div class="vx-row mb-6" style="width:70%">
                <div class="vx-col sm:w-1/4 w-full flex items-center">
                    <span>STO Number</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <StoNumber @selected="(val) => {
                        this.selectedStoNumber = val
                    }"></StoNumber>
                </div>
            </div>
            <div class="vx-row mb-6" style="width:70%">
                <div class="vx-col sm:w-1/4 w-full flex items-center">
                    <span>Dest. Warehouse</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <Warehouse @selected="(val) => {
                        this.selectedSrcWarehouse = val
                    }"></Warehouse>
                </div>
            </div>
            <div class="vx-row mb-6" style="width:70%">
                <div class="vx-col sm:w-1/4 w-full flex items-center">
                    <span>Delivery Date</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <Date :default="false" @selected="(val) => {
                        this.transactionDate = val
                    }"></Date>
                </div>
            </div>
            <div class="vx-row mb-6" style="width:70%">
                <div class="vx-col sm:w-1/4 w-full flex items-center">
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <vs-button 
                    color="primary" 
                    @click="handleFilter()"
                    >Filter</vs-button>
                </div>
            </div>
        </div>
        <div class="vx-row mt-3">
            <div class="vx-col w-full mb-base">
                <Table :draw="draw" 
                    :status="activeTab" 
                    :transaction-date="transactionDate"
                    :source-warehouse-id="(this.selectedSrcWarehouse) ? this.selectedSrcWarehouse.id : 0"
                    :sto-number-id="(this.selectedStoNumber) ? this.selectedStoNumber.id : 0">
                </Table>
            </div>
        </div>
    </div>
</template>

<script>
import StoNumber from "./component/StoNumber.vue";
import Warehouse from "./component/Warehouse.vue";
import Date from "./component/Date.vue";
import Table from "./component/Table.vue";
export default {
    components: {
        StoNumber,
        Warehouse,
        Date,
        Table
    },
    data() {
        return {
            activeTab: "Suggestion",
            draw: 0,
            transactionDate: null,
            selectedSrcWarehouse: null,
            selectedStoNumber: null
        }
    },
    methods: {
        handleFilter() {
            this.draw++
        },
    },
    watch: {
        // ...
    },
}
</script>